import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getPresentation(id, session_id=0) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/presentation/get?id='+id+'&session_id='+session_id);
      const items = await axios.get('/api/presentation/items?id='+id+'&session_id='+session_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_PRESENTATION', data: payload, items: items.data.payload })
        return data.payload;
      } else {
        dispatch({type: 'GET_PRESENTATION', data: {}, items: [] })

        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_PRESENTATION', data: {}, items: [] })
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getSessions(presentation_id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/presentation/sessions?presentation_id='+presentation_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_PRESENTATION_SESSIONS', data: payload, })
        return data.payload;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }
}

export async function getQuestionAnswer(session_id) {
 
  try {
    const {data} = await axios.get('/api/presentation/question-answer?session_id='+session_id);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
  
}


export async function genStatisticAnswerFile(session_id) {

    try {
        const {data} = await axios.get('/api/presentation/import-exel?session_id='+session_id);

        if(data.errcode == 200) {
            return {
              status: true,
              fileName: data.fileName,
            };
        } else {
          return {
            status: false
          };
        }
    } catch (error) {
      return {
        status: false
      };
    }

}

export async function getMessage(session_id) {
 
  try {
    const {data} = await axios.get('/api/presentation/student-message?session_id='+session_id);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
  
}

export function setPresentationSlide(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_PRESENTATION_SLIDE', data })
  }
}
export function clearPresentation(data) {
  return async (dispatch) => {
    dispatch({type: 'CLEAR_PRESENTATION' })
  }
}


export async function addSlideImage(body) {
  
    try {
      var bodyFormData = new FormData();
      bodyFormData.append('UploadFiles[imageFiles]', body.image );
      bodyFormData.append('pr_id', body.pr_id );
      bodyFormData.append('order_x', body.order_x );
      const {data} = await axios({
        method: 'post',
        url: '/api/presentation-item/post',
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      });

      if(data.errcode == 200) {
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return null; 
    }
}

export function addImages(images, pr_id, length = 0) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_PRESENTATION_LOADED_IMGS', data: false})
      let i=1;
      for(const file of images) {
        let data = await addSlideImage({
          image: file.item,
          pr_id,
          order_x: length + i ,
        });
        dispatch({type: 'ADD_PRESENTATION_ITEM', data })
        i++;
      }
      setTimeout(() => {
        dispatch({type: 'SET_PRESENTATION_LOADED_IMGS', data: true})
      }, 500);
      
      return true;
    } catch (error) {
      dispatch({type: 'SET_PRESENTATION_LOADED_IMGS', data: true})
    }
  }
}



export function setLoaded(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_PRESENTATION_LOADED', data})
  }
}

export function deletePresentationItem(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation-item/delete', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_PRESENTATION_ITEM', data: id});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deletePresentationItems(ids) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation-item/delete', {ids: JSON.stringify(ids)});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_PRESENTATION_ITEMS', data: ids});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export  function updatePresentationItemOrder(orders) {
  return async(dispatch) => {
    try {
      dispatch({type: 'SET_PRESENTATION_LOADED', data: false})
      const {data} = await axios.post('/api/presentation-item/order', {orders: JSON.stringify(orders)});
      dispatch({type: 'SET_PRESENTATION_ORDERS', data: orders})
      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'SET_PRESENTATION_LOADED', data: true})
        return data;
      } else {
        // TODO error
        dispatch({type: 'SET_PRESENTATION_LOADED', data: true})
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'SET_PRESENTATION_LOADED', data: true})
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/actions.js